"use client";
import styled from "styled-components";
import BrandFooterLogo from "/public/assets/images/logo/footer_logo.png";
import LinkIcon01 from "/public/assets/icons/sns/link-ico-01.png";
import LinkIcon02 from "/public/assets/icons/sns/link-ico-02.png";
import LinkIcon03 from "/public/assets/icons/sns/link-ico-03.png";
import {SIZES} from "@/components/constants";
import {useEffect} from "react";
import {observer} from "mobx-react";
import {useStore} from "@/store";
import {MODAL_PAYLOAD} from "@/components/constants/modal";
import {useMediaQuery} from "react-responsive";



const Footer = observer(({ref}) => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {modalStore, userStore} = useStore();
    useEffect(() => {
        userStore.getFooterData().then();
    }, []);
    return(
        <FooterWrap ref={ref}>
            <InfoWrap>
                <div className={"top-wrap"}>
                    <LogoArea><img src={BrandFooterLogo?.src} alt={"로고"}/></LogoArea>
                    {
                        isTablet &&
                        <SnsWrap>
                            <div className={"item"}>
                                <a
                                    href="https://www.youtube.com/@woongbeetv"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={LinkIcon01?.src} alt={"유투브 로고"}/>
                                </a>
                            </div>
                            <div className={"item"}>
                                <img src={LinkIcon02?.src} alt={"링크 로고"}/>
                            </div>
                            <div className={"item"}>
                                <a
                                    href="https://pf.kakao.com/_uYNsn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={LinkIcon03?.src} alt="카카오12 로고"/>
                                </a>
                            </div>
                        </SnsWrap>
                    }
                </div>
                <DescArea>
                    <div className={"service-area"}>
                        <div
                            className={"pointer"}
                            onClick={() => {
                                modalStore.openModal({
                                    ...MODAL_PAYLOAD.FOOTER_MODAL("개인정보처리방침", userStore.footerPrivacy)
                                });
                            }}
                        >
                            개인정보처리방침
                        </div>
                        <div
                            className={"pointer"}
                            onClick={() => {
                                modalStore.openModal({
                                    ...MODAL_PAYLOAD.FOOTER_MODAL("이용약관", userStore.footerRule)
                                });
                            }}
                        >
                            이용약관
                        </div>
                    </div>
                    <SiteInfoWrap>
                        <div className={"list"}>
                            <div className={"list-wrap"}>
                                <div className={"inner"}>
                                    <div className={"tit"}>사이트명</div>
                                    <div className={"cont"}>(주)웅비메디텍</div>
                                </div>
                                <div className={"inner"}>
                                    <div className={"tit"}>상호</div>
                                    <div className={"cont"}>(주)웅비메디텍</div>
                                </div>
                            </div>
                            <div className={"list-wrap"}>
                                <div className={"inner"}>
                                    <div className={"tit"}>대표</div>
                                    <div className={"cont"}>이웅섭</div>
                                </div>
                                <div className={"inner"}>
                                    <div className={"tit"}>전화</div>
                                    <div className={"cont"}>02-881-5432</div>
                                </div>
                            </div>
                        </div>
                        <div className={"list inner-mo"}>
                            <div className={"inner"}>
                                <div className={"tit"}>사업자등록번호</div>
                                <div className={"cont"}>220-81-38185</div>
                            </div>
                            {/*<div className={"inner"}>*/}
                            {/*    <div className={"tit"}>통신판매신고</div>*/}
                            {/*    <div className={"cont"}>제 2008-경기성남-0948 호</div>*/}
                            {/*</div>*/}
                        </div>
                        {/*<div className={"list"}>*/}
                        {/*    <div className={"inner"}>*/}
                        {/*        <div className={"tit"}>의료기기판매업신고번호</div>*/}
                        {/*        <div className={"cont"}>제2015-3780063-00024호</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={"list"}>
                            <div className={"inner"}>
                                <div className={"tit"}>주소</div>
                                <div className={"cont"}>
                                    {
                                        !isTablet ?
                                            <>( 05854 ) 서울특별시 송파구 송파대로 201 테라타워2 A동 1113호 (문정동 642번지)</>
                                            :
                                            <>( 05854 ) 서울특별시 송파구 송파대로 201 테라타워2<br />A동 1113호 (문정동 642번지)</>
                                    }

                                </div>
                            </div>
                        </div>
                    </SiteInfoWrap>
                    <div className={"copy-right-area"}>
                        {
                            !isTablet ?
                                <>Copyright ⓒ (주)웅비메디텍 All Rights Reserved Any Questions to woongbee@woongbee.com</>
                                :
                                <>Copyright ⓒ (주)웅비메디텍 All Rights Reserved<br />Any Questions to woongbee@woongbee.com</>
                        }
                    </div>
                </DescArea>
            </InfoWrap>
            {
                !isTablet &&
                <SnsWrap>
                    <div className={"item"}>
                        <a
                            href="https://www.youtube.com/@woongbeetv"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={LinkIcon01?.src} alt={"유투브 로고"}/>
                        </a>
                    </div>
                    <div className={"item"}>
                        <img src={LinkIcon02?.src} alt={"링크 로고"}/>
                    </div>
                    <div className={"item"}>
                        <a
                            href="https://pf.kakao.com/_uYNsn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={LinkIcon03?.src} alt="카카오 로고"/>
                        </a>
                    </div>
                </SnsWrap>
            }
        </FooterWrap>
    )
});
const SnsWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    .item {
        width: 44px;
        height: 44px;
        cursor: pointer;
    }
    @media (max-width: ${SIZES.TABLET}) {
        gap: 12px;
        .item{
            width: 32px;
            height: 32px;
        }
    }
`
const SiteInfoWrap = styled.div`
    .list{
        margin-top: 16px;
        display: flex;
        align-items: center;
        gap: 40px;
        &:first-child{
            margin: 0;
        }
        .list-wrap{
            display: flex;
            gap: 40px;
        }
        .inner{
            display: flex;
            align-items: center;
            gap: 10px;
            .tit{
                font-weight: 400;
                font-size: 16px;
                line-height: 100%;
                color: #CCCCCC;
            }
            .cont{
                font-weight: 700;
                font-size: 16px;
                line-height: 100%;
                color: #FFFFFF;
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .list{
            display: block;
            &.inner-mo{
                .inner{
                    margin-top: 16px;
                    &:first-child{
                        margin: 0;
                    }
                }
            }
            .list-wrap{
                margin-top: 16px;
                &:first-child{
                    margin: 0;
                }
            }
            .inner{

                .tit{
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                }
                .cont{
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 22px;
                }
            }
        }
    }
`
const DescArea = styled.div`
    .service-area{
        display: flex;
        align-items: center;
        gap: 32px;
        margin-bottom: 50px;
        div{
            font-weight: 700;
            font-size: 24px;
            line-height: 100%;
            color: #FFFFFF;
        }
    }
    .copy-right-area{
        margin-top: 50px;
        font-weight: 400;
        font-size: 16px;
        line-height: 120%;
        color: #CCCCCC;
    }
    @media (max-width: ${SIZES.TABLET}) {
        .service-area{
            margin-bottom: 56px;    
            div{
                font-weight: 700;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: -0.02em;
            }
        }
        .copy-right-area{
            font-weight: 700;
            font-size: 14px;
            line-height: 22px;
        }
    }
`
const LogoArea = styled.div`
    width: 285px;
    @media (max-width: ${SIZES.TABLET}) {
        width: 170px;
    }
`
const InfoWrap = styled.div`
    display: flex;
    gap: 120px;
    align-items: start;
    @media (max-width: ${SIZES.TABLET}) {
        flex-direction: column;
        gap: 56px;
        .top-wrap{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }
    }
`
const FooterWrap = styled.footer`
    background: #1B0751;
    padding: 120px 60px 140px;
    scroll-snap-align: start;
    display: flex;
    justify-content: space-between;
    align-items: start;
    width: 100%;
    overflow: hidden;
    @media (max-width: ${SIZES.TABLET}) {
        padding: 60px 16px;
        display: block;
    }
`
export default Footer;